import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delaySeconds: { type: Number, default: 8 },
    formId: String,
    registrationModal: String,
    submissionKey: { type: String, default: "tally_popup_submitted" },
  }

  connect() {
    if (this.submittedAlready()) return

    this.onMessage = this.handleMessage.bind(this)
    window.addEventListener("message", this.onMessage)

    const registrationModal = this.registrationModalValue
    if (registrationModal) {
      this.onRegistrationOpen = (event) => {
        if (event.target.id !== registrationModal) return
        clearTimeout(this.hideTimeout)
        this.close()
      }
      document.addEventListener("show.bs.modal", this.onRegistrationOpen)
    }

    const delay = Math.max(0, this.delaySecondsValue ?? 0) * 1000
    this.hideTimeout = window.setTimeout(() => this.show(), delay)
  }

  disconnect() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
    }

    if (this.onMessage) {
      window.removeEventListener("message", this.onMessage)
    }

    if (this.onRegistrationOpen) {
      document.removeEventListener("show.bs.modal", this.onRegistrationOpen)
    }
  }

  close() {
    this.element.classList.remove("is-visible")

    window.setTimeout(() => {
      this.element.classList.add("d-none")
    }, 200)
  }

  show() {
    this.element.classList.remove("d-none")

    // Let the browser paint before applying the visible class for transition
    requestAnimationFrame(() => {
      this.element.classList.add("is-visible")
    })
  }

  handleMessage(event) {
    if (event.origin !== "https://tally.so" || typeof event.data !== "string") return
    if (!event.data.includes("Tally.FormSubmitted")) return

    try {
      const message = JSON.parse(event.data)
      if (message?.payload?.formId !== this.formIdValue) return

      clearTimeout(this.hideTimeout)
      this.close()
      localStorage.setItem(this.submissionKeyValue, "true")
    } catch (error) {
      // Ignore unrelated or malformed cross-window messages.
    }
  }

  submittedAlready() {
    try {
      return localStorage.getItem(this.submissionKeyValue) === "true"
    } catch (error) {
      return false
    }
  }
}
